import React from "react"; 
import { Link } from "react-router-dom";    
import EditUserTypeForm from "../../../components/Dashboard/UserTypesListContent/Edit";

const EditUserType = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit User Type</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Edit User Type</li>
        </ul>
      </div> */}

      <EditUserTypeForm />
    </>
  );
};

export default EditUserType;
